import React from 'react';
import { Mail, Phone, Briefcase, Paperclip, Download, Type, Palette, Layout } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SelectionChip = ({ icon: Icon, label, value }) => (
  <div className="bg-gray-50 rounded-md p-3 flex items-center gap-2">
    <Icon className="h-5 w-5 text-[#7B1E2B]" />
    <div>
      <p className="text-xs text-gray-500">{label}</p>
      <p className="text-sm font-semibold text-[#001B2A]">{value || '—'}</p>
    </div>
  </div>
);

export const SubmissionCard = ({ sub }) => (
  <div data-testid={`submission-card-${sub.id}`} className="bg-white rounded-lg shadow-md p-6">
    <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
      <div>
        <h2 className="text-xl font-serif font-bold text-[#001B2A]">{sub.name}</h2>
        <div className="flex flex-wrap gap-4 mt-2 text-sm text-gray-600">
          <span className="flex items-center gap-1.5"><Mail className="h-4 w-4" />{sub.email}</span>
          {sub.phone && <span className="flex items-center gap-1.5"><Phone className="h-4 w-4" />{sub.phone}</span>}
          {sub.business_name && <span className="flex items-center gap-1.5"><Briefcase className="h-4 w-4" />{sub.business_name}</span>}
        </div>
      </div>
      <span className="text-xs text-gray-400">
        {new Date(sub.created_at).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' })}
      </span>
    </div>

    <div className="grid sm:grid-cols-3 gap-3 mb-4">
      <SelectionChip icon={Type} label="Font" value={sub.selections?.font?.name} />
      <SelectionChip icon={Palette} label="Colors" value={sub.selections?.color?.name} />
      <SelectionChip icon={Layout} label="Layout" value={sub.selections?.layout?.name} />
    </div>

    {sub.notes && (
      <div className="mb-4 bg-[#E6D7B3]/30 border border-[#E6D7B3] rounded-md p-4">
        <p className="text-xs font-semibold text-gray-500 uppercase mb-1">Notes</p>
        <p className="text-sm text-gray-700 whitespace-pre-wrap">{sub.notes}</p>
      </div>
    )}

    {sub.files?.length > 0 && (
      <div>
        <p className="text-xs font-semibold text-gray-500 uppercase mb-2">Attached Files</p>
        <div className="flex flex-wrap gap-2">
          {sub.files.map((f) => (
            <a
              key={f.filename}
              href={`${API_URL}/api/design-submissions/${sub.id}/files/${encodeURIComponent(f.filename)}`}
              className="flex items-center gap-2 px-3 py-2 bg-gray-100 hover:bg-[#7B1E2B] hover:text-white rounded-md text-sm text-gray-700 transition-colors"
              data-testid={`file-download-${f.filename}`}
            >
              <Paperclip className="h-4 w-4" />
              {f.filename}
              <Download className="h-3.5 w-3.5" />
            </a>
          ))}
        </div>
      </div>
    )}
  </div>
);
